module.exports = __webpack_public_path__ + "static/media/diamonds.33678317.png";